import { render, staticRenderFns } from "./SmsPush.vue?vue&type=template&id=c5673fba&scoped=true&"
import script from "./SmsPush.vue?vue&type=script&lang=ts&"
export * from "./SmsPush.vue?vue&type=script&lang=ts&"
import style0 from "./SmsPush.vue?vue&type=style&index=0&id=c5673fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5673fba",
  null
  
)

export default component.exports